export default "__VITE_ASSET__D2Oh8O_D__"